import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBTuqwjs6wk0PVG4dplhm9OrPtpsWE-LOA",
  authDomain: "content-hosting-c80ed.firebaseapp.com",
  projectId: "content-hosting-c80ed",
  storageBucket: "content-hosting-c80ed.firebasestorage.app",
  messagingSenderId: "432078822194",
  appId: "1:432078822194:web:e2f6f6ec0566bcf0c6552b",
  measurementId: "G-KEPMZKZHBT"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
